import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom, Observable } from 'rxjs';

import { GenericException } from '../../../core/logic/exception';

@Injectable()
export class LoggerRepository {
  private readonly loggerInsert: (data: unknown) => Observable<void>;
  private readonly loggerInsertInGoogleCloud: (
    data: unknown,
  ) => Observable<void>;
  private _who: string;

  set who(value: string) {
    this._who = value ?? 'Inconnu';
  }

  get who(): string {
    return this._who;
  }

  constructor(private functions: AngularFireFunctions) {
    this.loggerInsert = this.functions.httpsCallable<unknown, void>(
      'logger-insert',
    );
    this.loggerInsertInGoogleCloud = this.functions.httpsCallable<
      unknown,
      void
    >('logger-insertLogGoogle');
  }

  async debug(
    location: string,
    message: string,
    trace?: unknown | undefined,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.loggerInsert({
          gravity: 'DEBUG',
          location,
          message,
          who: this.who,
          trace: trace ? JSON.stringify(trace) : trace,
        }),
      );
    } catch (error) {
      throw new GenericException(error);
    }
  }

  async debugCloud(
    location: string,
    message: string,
    data?: unknown | undefined,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.loggerInsertInGoogleCloud({
          gravity: 'DEBUG',
          location,
          message,
          who: this.who,
          data,
        }),
      );
    } catch (error) {
      throw new GenericException(error);
    }
  }

  async info(
    location: string,
    message: string,
    trace?: unknown | undefined,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.loggerInsert({
          gravity: 'INFO',
          location,
          message,
          who: this.who,
          trace: trace ? JSON.stringify(trace) : trace,
        }),
      );
    } catch (error) {
      throw new GenericException(error);
    }
  }

  async warn(
    location: string,
    message: string,
    trace?: unknown | undefined,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.loggerInsert({
          gravity: 'WARN',
          location,
          message,
          who: this.who,
          trace: trace ? JSON.stringify(trace) : trace,
        }),
      );
    } catch (error) {
      throw new GenericException(error);
    }
  }

  async error(
    location: string,
    message: string,
    trace?: unknown | undefined,
  ): Promise<void> {
    try {
      await firstValueFrom(
        this.loggerInsert({
          gravity: 'ERROR',
          location,
          message,
          who: this.who,
          trace: trace ? JSON.stringify(trace) : trace,
        }),
      );
    } catch (error) {
      throw new GenericException(error);
    }
  }
}
